import styled from "styled-components";

export const Background = styled.div`
  background-color: white;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  @media (min-width: 768px) {
    margin: 0 4rem;
    margin-top: 2rem;
  }

  @media (height: 647px) {
    height: 98%;
  }
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: row;
    margin: 10px 20px 0px 0;
    display: block;
  }

  .title {
    display: flex;

    @media (max-width: 768px) {
      margin-left: -10px;
    }

    img {
      margin: 0;

      @media (max-width: 768px) {
        width: 12%;
      }

      @media (min-width: 768px) {
        margin-bottom: 1rem;
      }
    }
  }

  h3 {
    margin: 0.35rem 0 0 1.2rem;
    color: #808080;

    @media (max-width: 768px) {
      font-size: 1.4rem;
    }
  }
`;

export const Main = styled.div`
  width: 100%;
  background-color: #ffffff;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin: 0px;
  }

  p {
    color: #808080;
    margin-left: 10px;
  }

  p > p {
    margin-left: 0;
  }

  p ul {
    margin-left: 3rem;
    @media (max-width: 769px) {
      margin-left: 20px;
    }
  }

  table {
    margin-left: 0.7rem;
  }

  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }

  table {
    width: 50%;
    @media (min-width: 769px) {
      width: 70%;
    }
  }

  td {
    padding: 10px;
  }

  @media (max-width: 1220px) {
    table {
      width: 100%;
    }
  }
`;

export const BackIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 0 2rem 0;
  cursor: pointer;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const Bold = styled.span`
  color: ${({ color }) => color};
  font-weight: 900;
`;
